<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Purchase and Activate Using a Credit Card
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>
            <p>
                Once you have the software installed, follow these steps to purchase and activate
                your license.
            </p>

            <p>
                If you need the setup file to install the software, go to the corresponding downloads page:
            </p>
            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/LoopCAD'>Download LoopCAD</router-link></li>
                <li><router-link to='/Download/HeatCAD'>Download HeatCAD</router-link></li>
                <li><router-link to='/Download/PlumbingCAD'>Download PlumbingCAD</router-link></li>
            </ul>

            <ol class='help-listStyle q-mt-lg'>
                <li>
                    Run the program
                    <span class='text-weight-medium'>on the computer that you want activated</span>.
                </li>
                <li>
                    <p>If the Activation window does not automatically open, click the <span class='text-weight-medium'>Activate</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>Click the '<span class='text-weight-medium'>Purchase or Renew License</span>' option. This will take you to the activation website.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/PurchaseOrRenewLink.jpg')" />
                </li>
                <li>
                    The website will now open with the option '<span class='text-weight-medium'>Purchase and Activate a new license</span>'. Click <span class='text-weight-medium'>Continue</span> to proceed.
                </li>
                <li>
                    <p>Select the desired edition: MJ8, Professional, or Standard. <span class='note'> (The available Edition options will vary with program.) </span></p>
                    <img class="img-fit" :src="require('@/assets/img/help/EditionSelection.jpg')" />
                </li>
                <li>
                    <p>If applicable, input your <span class='text-weight-medium'>Discount Code</span> in the field provided, including any dashes.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/DiscountCode_Website.jpg')" />
                </li>
                <li>
                    Click <span class='text-weight-medium'>Continue</span>, and follow the remaining steps to complete the purchase. If you do not have an online account yet, create a new one when prompted.
                </li>
                <li>
                    When you get to the shopping cart page, click <span class='text-weight-medium'>Continue</span> to proceed with the checkout process.
                </li>
                <li>
                    <p>When completed, the Activation Code will be displayed on screen and will also be sent to you by email.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/ActivationCodeField.jpg')" /></p>
                    <p>For help on entering your new activation code, see the <router-link to='/Support/Help/Enter-Activation'>Entering an Activation Code</router-link> help topic.</p>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'purchase-credit-card',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>
